import * as Yup from "yup";

export const VALIDATION_SCHEMA_ADD_ADMIN = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email.").required("Required"),
  userRole: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});
